document.addEventListener("DOMContentLoaded", function() {
    // Get the full URL
    var urlParams = new URLSearchParams(window.location.search);
    var sizeSelected = null;
    var colorSelected = null;
    $(".engrave-cards-container").click(function() {
        if ($(this).hasClass("selected-engrave-cards-container")) {
            return;
        }
        $(".pdpLoader").show();
        $(".engrave-cards-container").removeClass(
            "selected-engrave-cards-container"
        );
        $(this).addClass("selected-engrave-cards-container");
        var url = $(".call-sm").val();
        var urlEngrave = $(".call-engrave").val();
        var cardType = $(this).data("name");
        var urlToUse = cardType === "QR" ? url : urlEngrave;

        $.ajax({
            url:     urlToUse,
            method:  "GET",
            success: function(response) {
                console.log("Response:", response);
            },
            error: function(xhr, status, error) {
                console.log("AJAX error:", error);
            }
        });

        // Check if all selected to handle desktop scroll
        if (checkIfAllSelected()) {
            handleDesktopScroll();
        }
    });

    var upButton = document.querySelector(".up-button");
    var downButton = document.querySelector(".down-button");
    var imagesWrapper = document.querySelector(".images-wrapper");
    var productImages = imagesWrapper.querySelectorAll(".product-colors-image");
    var imageHeight = 88 + 5 * 2; // Image height (88px) + margin (8px * 2)

    var visibleImagesCount = 5;
    var currentPosition = 0;
    var sizeContainers = document.querySelectorAll(
        ".customize-size-container-variation"
    );
    var colorContainers = document.querySelectorAll(
        ".customize-color-container"
    );
    
    window.resetThumbnailScroll = function() {
    currentPosition = 0;
    };
    // Calculate the max scroll position based on the number of images
    function calculateMaxScroll() {
        var currentImagesWrapper = document.querySelector(".images-wrapper");
        if (!currentImagesWrapper) return 0;
        var currentProductImages = currentImagesWrapper.querySelectorAll(".product-colors-image");
        return -((currentProductImages.length - visibleImagesCount) * imageHeight);
    }

    // Function to check if all options are selected
    function checkIfAllSelected() {
    //eslint-disable-line

        if (sizeContainers.length == 0 && colorContainers.length == 0) {
            return true;
        }

        if (sizeContainers.length != 0 && colorContainers.length != 0) {
            return sizeSelected && colorSelected;
        } else {
            if (sizeContainers.length != 0 && sizeSelected != null) {
                return true;
            } else {
                if (colorContainers.length != 0 && colorSelected != null) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    // Scroll functionality for product images
    if (upButton) {
        upButton.addEventListener("click", function() {
            if (currentPosition < 0) {
                currentPosition += imageHeight;
                var imagesWrapper = document.querySelector(".images-wrapper");
                if (imagesWrapper) {
                    imagesWrapper.style.transform = "translateY(" + currentPosition + "px)";
                }
            }
        });
    }

    if (downButton) {
        downButton.addEventListener("click", function() {
            var maxScroll = calculateMaxScroll(); 
            if (currentPosition > maxScroll) {
                currentPosition -= imageHeight;
                var imagesWrapper = document.querySelector(".images-wrapper");
                if (imagesWrapper) {
                    imagesWrapper.style.transform = "translateY(" + currentPosition + "px)";
                }
            }
        });
    }

    // Handle size selection
    $("body").on("click", ".customize-size-container-variation", function () {
        $("#sizeHeader").html("Size: ");

        // active styles
        $(".customize-size-container-variation").removeClass("customize-size-container-active");
        $(this).addClass("customize-size-container-active");

        sizeSelected = this.getAttribute("data-size");

        document.querySelectorAll(".customize-size").forEach(function (el) {
            el.innerHTML = sizeSelected;
        });

        $("#sizeHeader").removeClass("errorState");
        $("#sizeErrorMessage").text("").hide();
        $(".customizeid-sizechart .customize-size-container").removeClass("size-error-state");

        // IMPORTANT: trigger SFRA size variation AJAX (this is what refreshes available colors)
        var inner = this.querySelector(".size-custom-attribute");
        if (inner) {
            $(inner).trigger("click"); // jQuery-trigger ensures SFRA delegated handler sees it
        }
    });

    var selectedSizeContainer = document.querySelector(
        ".customize-size-container-variation.selected"
    );
    if (selectedSizeContainer) {
        selectedSizeContainer.classList.add("customize-size-container-active"); // Ensure it's visually active
        sizeSelected = selectedSizeContainer.getAttribute("data-size");
        document.querySelectorAll(".customize-size").forEach(function(element) {
            element.innerHTML = sizeSelected;
        });
        $("#sizeHeader").html("Size: ");
    }

    $("#EngraveCheckbox").on("change", function() {
        if ($(this).prop("checked")) {
            // Reset styles if the checkbox is checked
            $(".custom-checkbox-container .checkmark").css({
                "border-color": "#051424"
            });
            $(".declaration .text").css("color", "#051424");
        } else {
            $("#engravingline3").val("");
            $("#engravingline4").val("");
            $("#pengravingline3").text("");
            $("#pengravingline4").text("");
        }
    });

    function setColorA11yError(message) {
        // Do NOT add .errorState (that’s what turns it red)
        $("#colorHeader").attr("aria-invalid", "true");
        $("#colorStatus").text(message || "Please select a color.");
    }

    function clearColorA11yError() {
        $("#colorHeader").removeAttr("aria-invalid");
        $("#colorStatus").text("");
    }

    function updateUrlFromSelectedProductUrl(selectedProductUrl) {
        if (!selectedProductUrl) return;
        var absolute = new URL(selectedProductUrl, window.location.origin).toString();
        var cleaned = cleanVariantUrl(absolute);
        window.history.replaceState({}, document.title, cleaned);
    }

    function syncSelectedLabelsFromDom() {
        // COLOR
        var activeColor =
            document.querySelector(".customize-color-container.customize-color-active") ||
            document.querySelector(".customize-color-container.selected");

        if (activeColor) {
            var c = activeColor.getAttribute("data-attr-value") || "";
            colorSelected = activeColor.classList.contains("unselectable") ? null : c;
            if (c) {
                $("#colorHeader").html("Color: ");
                document.querySelectorAll(".customize-color").forEach(function (el) { el.innerHTML = c; });
            }
        }

        // SIZE
        var activeSize =
            document.querySelector(".customize-size-container-variation.customize-size-container-active") ||
            document.querySelector(".customize-size-container-variation.selected");

        if (activeSize) {
            var s = activeSize.getAttribute("data-size") || "";
            sizeSelected = s || null;
            if (s) {
                $("#sizeHeader").html("Size: ");
                document.querySelectorAll(".customize-size").forEach(function (el) { el.innerHTML = s; });
            }
        }
    }

    

    $("body").on("product:afterAttributeSelect", function (evt, payload) {
        if (!payload || !payload.data || !payload.data.product) return;

        // 1) Keep the URL updated (no page reload)
        updateUrlFromSelectedProductUrl(payload.data.product.selectedProductUrl);

        // 2) Sync the "Color:" / "Size:" labels + variables after SFRA rerenders the markup
        syncSelectedLabelsFromDom();

        // 3) Update CTA based on new variant availability
        var product = payload.data.product;
        var isReadyToOrder = !!product.readyToOrder;
        var isAvailable = !!product.available;

        // Do not show/lock Out of Stock until a real variant combination is selected.
        if (!isReadyToOrder) {
            clearCtaOutOfStock("Next");
        } else if (!isAvailable) {
            setCtaOutOfStock();
        } else {
            clearCtaOutOfStock("Next");
        }
        
    });    

    function cleanVariantUrl(urlString) {
        try {
            var url = new URL(urlString, window.location.origin);

            // Always keep these (core variation state)
            var keep = new Set();
            url.searchParams.forEach(function (_, key) {
                if (key.indexOf("dwvar_") === 0) keep.add(key);
            });

            // Optional: keep membership plan ONLY if you want it shareable
            // keep.add("dwopt_A6013000_membershipPlans");

            // Remove known noisy defaults
            if (url.searchParams.get("quantity") === "1") url.searchParams.delete("quantity");

            // Remove pid (often unnecessary once dwvar is present)
            url.searchParams.delete("pid");

            // Now remove any param not in keep list
            Array.from(url.searchParams.keys()).forEach(function (key) {
                if (!keep.has(key)) url.searchParams.delete(key);
            });

            return url.pathname + (url.searchParams.toString() ? "?" + url.searchParams.toString() : "");
        } catch (e) {
            return urlString; // fallback: do nothing
        }
    } 

    function applyVariationResponse(resp) {
        if (!resp || !resp.product) return;

        var product = resp.product;

        // 1) Update price
        if (product.renderedPrice) {
            $(".price").first().replaceWith(product.renderedPrice);
        }

        // 2) Update main image (safe fallback)
        if (product.images && product.images.large && product.images.large[0]) {
            var img = product.images.large[0];
            var mainImg = document.querySelector(".Product-image img");
            if (mainImg && img.url) {
                mainImg.setAttribute("src", img.url);
                mainImg.setAttribute("alt", img.alt || "");
            }
        }

        // 3) Update CTA based on availability
        var isAvailable = !!product.available;
        var ctaBtn = document.getElementById("customizeidQr") || document.getElementById("customizeid");
        if (ctaBtn) {
            if (!isAvailable) {
                setCtaOutOfStock();
            } else {
                clearCtaOutOfStock("Next");
                ctaBtn.removeAttribute("disabled");
                ctaBtn.removeAttribute("aria-disabled");
                ctaBtn.style.pointerEvents = "auto";
                ctaBtn.style.opacity = "1";
            }
        }

        // 4) Update color/size label text from variationAttributes (source of truth)
        if (product.variationAttributes && product.variationAttributes.length) {
            var colorAttr = product.variationAttributes.find(function(a){ return a.id === "color"; });
            var sizeAttr  = product.variationAttributes.find(function(a){ return a.id === "size"; });

            if (colorAttr && colorAttr.displayValue) {
                colorSelected = colorAttr.displayValue;
                document.querySelectorAll(".customize-color").forEach(function(el){ el.innerHTML = colorSelected; });
                $("#colorHeader").html("Color: ");
            }

            if (sizeAttr && sizeAttr.displayValue) {
                sizeSelected = sizeAttr.displayValue;
                document.querySelectorAll(".customize-size").forEach(function(el){ el.innerHTML = sizeSelected; });
                $("#sizeHeader").html("Size: ");
            }
        }

        // 5) Refresh swatch availability (this fixes “start OOS + size selected = no color updates”)
        //    We update data-url + unselectable classes based on the response URLs.
        if (product.variationAttributes && product.variationAttributes.length) {
            product.variationAttributes.forEach(function(attr){
                if (!attr.values) return;

                if (attr.id === "color") {
                    attr.values.forEach(function(v){
                        // match by displayValue or value
                        $(".customize-color-container").each(function(){
                            var $c = $(this);
                            var label = $c.attr("data-attr-value");
                            if (label === v.displayValue || label === v.value) {
                                if (v.url) {
                                    $c.attr("data-url", v.url);
                                    $c.removeClass("unselectable");
                                } else {
                                    $c.removeAttr("data-url");
                                    $c.addClass("unselectable");
                                }
                            }
                        });
                    });
                }

                if (attr.id === "size") {
                    attr.values.forEach(function(v){
                        $(".size-custom-attribute").each(function(){
                            var $s = $(this);
                            var val = $s.attr("data-attr-value");
                            if (val === v.value) {
                                if (v.url) {
                                    $s.attr("data-url", v.url);
                                    $s.closest(".customize-size-container-variation").removeClass("color-out-of-stock");
                                } else {
                                    $s.removeAttr("data-url");
                                    $s.closest(".customize-size-container-variation").addClass("color-out-of-stock");
                                }
                            }
                        });
                    });
                }
            });
        }

        // 6) Update URL (no reload)
        if (product.selectedProductUrl) {
            var absolute = new URL(product.selectedProductUrl, window.location.origin).toString();
            var cleaned = cleanVariantUrl(absolute);
            window.history.replaceState({}, document.title, cleaned);
        }
    }

    function handleColorSelection(colorContainer) {
    // Check if there is only one color and prevent unselecting

        // --- NEW: prevent selecting out-of-stock/unselectable colors
        var colorUrl = colorContainer.getAttribute("data-url");
        var isUnselectable = colorContainer.classList.contains("unselectable") || !colorUrl;

        if (isUnselectable) {
            // Make it behave like "no valid selection"
            colorSelected = null;

            // Optional UI feedback
            setColorA11yError("Please select an in-stock color.");
            $(".customize-color-container").each(function() {
                $(this).addClass("color-error-state");
            });

            return;
        }

        if (colorContainers.length === 1) {
            return; // Exit without changing anything
        }
        if (colorContainer.classList.contains("selected")) {
            // If already selected, reset
            colorSelected = null;
            $("#colorHeader").html("Select Your Color: ");
            colorContainer.classList.remove("customize-color-active");

            document.querySelectorAll(".customize-color").forEach(function(element) {
                element.innerHTML = "";
            });
            currentPosition = 0;
        } else {
            // If not selected, update selection
            $("#colorHeader").html("Color: ");

            // Remove active class from all
            colorContainers.forEach(function(container) {
                container.classList.remove("customize-color-active");
            });

            // Add active class to the clicked one
            colorContainer.classList.add("customize-color-active");

            colorSelected = colorContainer.getAttribute("data-attr-value");
            
            // --- FIX: data-url points to Product-Variation (JSON endpoint).
            // Fetch it via AJAX, then redirect to the real HTML PDP URL from the response.
            var nextUrl = colorContainer.getAttribute("data-url");
            if (nextUrl) {
                $(".pdpLoader").show();

                $.ajax({
                    url: nextUrl,
                    method: "GET",
                    success: function (resp) {
                        $(".pdpLoader").hide();
                        applyVariationResponse(resp);
                    },
                    error: function () {
                        $(".pdpLoader").hide();
                        // Keep user on current page; optionally surface a message
                    }
                });

                return;
            }

            var colorName = colorSelected; // Just a more readable name

            document.querySelectorAll(".customize-color").forEach(function(element) {
                element.innerHTML = colorName;
            });
            currentPosition = 0;
        }
    }   

    // Add event listeners for clicks
    $("body").on("click", ".customize-color-container", function () {
        handleColorSelection(this);
        if (colorSelected !== null) {
        $("#colorHeader").removeClass("errorState");
        $("#colorErrorMessage").text("").hide();
        clearColorA11yError();
        $(".customize-color-container").removeClass("color-error-state");
    }
    });

    var selectedColorContainer = document.querySelector(
        ".customize-color-container.selected"
    );
    if (selectedColorContainer) {

        // --- NEW: if preselected color is out-of-stock/unselectable, do NOT allow proceeding
        var selectedColorUrl = selectedColorContainer.getAttribute("data-url");
        var preselectedIsOOS = selectedColorContainer.classList.contains("unselectable") || !selectedColorUrl;

        if (preselectedIsOOS) {
            colorSelected = null;

            colorContainers.forEach(function(container) {
                container.classList.remove("customize-color-active");
            });
            selectedColorContainer.classList.add("customize-color-active");

            var preselectedValue = selectedColorContainer.getAttribute("data-attr-value") || "";
            $("#colorHeader").html("Color: ");
            document.querySelectorAll(".customize-color").forEach(function(element) {
                element.innerHTML = preselectedValue;
            });

            // disable whichever CTA exists
            setCtaOutOfStock();

            setColorA11yError("Please select an in-stock color.");
            // return;
        }
        else{
            selectedColorContainer.classList.add("customize-color-active"); // Ensure it's visually active
            colorSelected = selectedColorContainer.getAttribute("data-attr-value");

            // Update UI with the selected color name
            document.querySelectorAll(".customize-color").forEach(function(element) {
                element.innerHTML = colorSelected;
            });

            $("#colorHeader").html("Color: ");
            var pid = $(".product-id")[0].textContent;
            var dataUrl = $("#selectedVariationURL").attr("data-url");
            var pathname = window.location.pathname;
            if (pathname && typeof pathname === 'string') {
                var withoutExtension = pathname.slice(0, pathname.lastIndexOf('.html'));
            }
            if(withoutExtension){
                var lastSlashIndex = withoutExtension.lastIndexOf('/');
                var editPid = withoutExtension.slice(lastSlashIndex + 1);
            }
            console.log('wzard edit pid', editPid);
            $.ajax({
                url:    dataUrl,
                method: "POST",
                data:   { 
                    selectedVariant: pid,
                    editPid:         editPid
                },
                success: function(response) {
                    if (response.inCart && !response.editingProduct) {
                        $("#customizeid , #customizeidQr")
                            .text("Already In Your Cart")
                                .css({ opacity: "0.5", "pointer-events": "none" })
                                .attr("aria-disabled", "true")
                                .attr("disabled", "disabled");
                    } else {
                        $("#customizeid , #customizeidQr")
                            .css({ opacity: "1", "pointer-events": "auto" })
                            .removeAttr("aria-disabled")
                            .removeAttr("disabled");
                    }
                },
                error: function(err) {
                    console.error("Error fetching product variation:", err);
                }
            });
        }      

    }

    // Handle product image selection
    productImages.forEach(function(imageContainer) {
        imageContainer.addEventListener("click", function() {
            // Update selected image
            var imageSelected = this.querySelector("img").getAttribute("src");
            document
                .querySelector(".Product-image img")
                .setAttribute("src", imageSelected);

            productImages.forEach(function(img) {
                return img.classList.remove("product-colors-image-border");
            });
            this.classList.add("product-colors-image-border");

            // checkIfAllSelected();
        });
    });

    var firstColumn = document.querySelector(".product-container-col");
    var secondColumn = document.querySelector(".customizeid-col");
    var containerRow = document.querySelector(".product-container-row");

    var Imagewrappercontainer = document.querySelector(
        ".images-wrapper-container"
    );

    Imagewrappercontainer.addEventListener("scroll", function() {
        if (window.innerWidth < 767) {
            if (Imagewrappercontainer.scrollLeft > 0) {
                Imagewrappercontainer.style.marginLeft = "0px"; // Remove left margin when scrolling
            } else {
                Imagewrappercontainer.style.marginLeft = "16px"; // Restore margin when scrolled back
            }
        }
    });

    var isScrollingTogether = false; // Track whether the columns are scrolling together

    var handleScroll = function() {
        var isDesktop = window.innerWidth > 1200; // Desktop breakpoint
        if (!isDesktop) return; // Exit if not on desktop

        var firstColumnRect = firstColumn.getBoundingClientRect();
        var secondColumnRect = secondColumn.getBoundingClientRect();
        var containerRect = containerRow.getBoundingClientRect();

        // Check if the second column has reached the bottom of the first column
        if (secondColumnRect.bottom <= firstColumnRect.bottom) {
            if (isScrollingTogether) {
                isScrollingTogether = true; // Update state to scrolling together
                firstColumn.style.position = "relative";
                firstColumn.style.top =
          "" + secondColumnRect.top - containerRect.top + "px";
            }
        } else if (secondColumnRect.top <= containerRect.top) {
            // Reset sticky behavior when scrolling back up
            if (!isScrollingTogether) {
                isScrollingTogether = false; // Update state to not scrolling together
                firstColumn.style.position = "sticky";
                firstColumn.style.top = "88px";
            }
        }
    };

    window.addEventListener("scroll", handleScroll);

    // Re-check window size on resize to enable/disable the function dynamically
    window.addEventListener("resize", function() {
        var isDesktop = window.innerWidth >= 1200; // Desktop breakpoint
        if (!isDesktop) {
            // Reset styles if switching to mobile
            firstColumn.style.position = "";
            firstColumn.style.top = "";
        }
    });

    // Helper function to smoothly scroll to an element
    // eslint-disable-next-line es/no-default-parameters
    function smoothScrollToElement(element, offset = 0) {
        var elementPosition =
      element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
            top:      elementPosition - 300,
            behavior: "smooth"
        });
    }

    // Desktop: Trigger scroll when validation is complete
    function handleDesktopScroll() {
    var ctaElement = document.querySelector("#customizeidQr") || document.querySelector("#customizeid");
    var desktopOffset = 100;
    if (ctaElement) smoothScrollToElement(ctaElement, desktopOffset);
    }
    
    var customizeid = document.getElementById("customizeid");
    var pdpEditbutton = document.getElementById("pdpEditbutton");
    var customizeidQr = document.getElementById("customizeidQr");

    function setCtaOutOfStock() {
        var btn = document.getElementById("customizeidQr") || document.getElementById("customizeid");
        if (!btn) return;

        btn.classList.add("out-of-stock-button");
        btn.textContent = "Out Of Stock";

        btn.disabled = true;
        btn.setAttribute("disabled", "disabled");
        btn.setAttribute("aria-disabled", "true");

        btn.style.pointerEvents = "none";
        btn.style.opacity = "0.5";
    }

    function clearCtaOutOfStock(defaultText) {
        var btn = document.getElementById("customizeidQr") || document.getElementById("customizeid");
        if (!btn) return;

        btn.classList.remove("out-of-stock-button");

        // Important: remove the actual disabled state.
        btn.disabled = false;
        btn.removeAttribute("disabled");
        btn.removeAttribute("aria-disabled");

        btn.style.pointerEvents = "auto";
        btn.style.opacity = "1";

        if (defaultText) {
            btn.textContent = defaultText;
        }
    }

    if (pdpEditbutton) {
        pdpEditbutton.addEventListener("click", function() {
            document.querySelector(".custom-engrave-container").classList.add("d-none");
            document.querySelector(".engravepdplikeheader").classList.remove("d-none");
            document.querySelector(".engrave-plp-card-container").classList.remove("d-none");
            document.querySelector(".productOnlyContainerPDP").classList.remove("d-none");

            // $(".engraveBar").addClass("d-none");
            $(".engraveBar").removeClass("Wizard-account");
            $(".Wizard-account-bar, .Wizard-engrave-bar").css("background-color", "#828991");
            $(".Wizard-engrave").removeClass("progress-active");
            $(".Wizard-account").removeClass("progress-deactive");
            $(".Wizard-account").addClass("progress-active");
            $(".Wizard-checked-circle-account").removeClass("Wizard-account-circle");
        });
    }

    // prevents the script from breaking on pages that we do not have it.
    if (customizeid) {
    customizeid.addEventListener("click", function() {
        window.scrollTo({
        top: 0,
        behavior: "smooth"
        });

        if (checkIfAllSelected()) {
        document.querySelector(".custom-engrave-container").classList.remove("d-none");
        document.querySelector(".engravepdplikeheader").classList.add("d-none");
        document.querySelector(".engrave-plp-card-container").classList.add("d-none");
        document.querySelector(".productOnlyContainerPDP").classList.add("d-none");

        $(".engraveBar").removeClass("d-none");
        $(".Wizard-account-bar, .Wizard-engrave-bar").css("background-color", "#0f7ef8");
        $(".Wizard-engrave").addClass("progress-active");
        $(".Wizard-account").removeClass("progress-active").addClass("progress-deactive");
        $(".Wizard-checked-circle-account").addClass("Wizard-account-circle");
        } else {
        if (colorSelected == null) {
            $("#colorHeader").addClass("errorState");
            $("#colorErrorMessage").text("Please select a color to continue.").show();
            setColorA11yError("Please select a color to continue.");
            $(".customize-color-container").each(function() {
            $(this).addClass("color-error-state");
            });
        }
        if (sizeSelected == null) {
            $("#sizeHeader").addClass("errorState");
            $("#sizeErrorMessage").text("Please select a size to continue.").show();
            $(".customizeid-sizechart .customize-size-container").each(function() {
            $(this).addClass("size-error-state");
            });
        }
        }
    });
    }

    if(customizeidQr){
        customizeidQr.addEventListener("click", function() {
            window.scrollTo({
                top:      0,
                behavior: "smooth" // Enables smooth scrolling
            });
            if (checkIfAllSelected()) {
                // Check if all options are selected
                var pid = null;
                $(".modern-product-detail").each(function() {
                    pid = $(this).find(".product-id").text();
                });
                var idType = $("#idType").text().trim();
                var url = $(".move-to-plan").val();
                $.ajax({
                    url:  url,
                    type: "POST",
                    data: {
                        pid:    pid,
                        idType: idType
                    },
                    success: function(response) {
                        if (response.redirectUrl) {
                            window.location.href = response.redirectUrl;
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log("Error:", error);
                    }
                });
            } else {
                if (colorSelected == null) {
                    $("#colorHeader").addClass("errorState");
                    $("#colorErrorMessage").text("Please select a color to continue.").show();
                    setColorA11yError("Please select a color to continue.");
                    $(".customize-color-container").each(function() {
                        $(this).addClass("color-error-state");
                    });
                }
                if (sizeSelected == null) {                   
                    $("#sizeErrorMessage").text("Please select a size to continue.").show();
                    $("#sizeHeader").addClass("errorState");
                    $(".customizeid-sizechart .customize-size-container").each(function() {
                        $(this).addClass("size-error-state");
                    });
                }
            }
        });
    }

    document.querySelectorAll(".engraveInput").forEach(function(input) {
        var counter = input.nextElementSibling; // Selects the adjacent counter div
        input.addEventListener("input", function() {
            var previewId = "p" + input.id;
            var previewElement = document.getElementById(previewId);
            if (previewElement) {
                previewElement.textContent = input.value; // Update preview with input value
            }
            var maxLength = input.getAttribute("maxlength");
            var remaining = maxLength - input.value.length;
            counter.textContent = remaining; // Updates the counter text
        });
    });

    // Handle Read More functionality
    document.querySelectorAll(".read-more").forEach(function(button) {
        button.addEventListener("click", function(event) {
            toggleReadMore(this, event);
        });
    });

    function toggleReadMore(button, event) {
        event.stopPropagation(); // Prevent accordion collapse
        var body = button.previousElementSibling;
        var isExpanded = body.classList.toggle("expanded");
        button.textContent = isExpanded ? "Read Less" : "Read More";
    }

    function updateLinkTarget() {
        var link = document.querySelector(".plp-Accordian-body a"); // Select the link
        if (window.innerWidth <= 768) {
            link.setAttribute("target", "_self");
        } else {
            link.setAttribute("target", "_blank");
        }
    }

    // Run function on page load
    updateLinkTarget();

    // Listen for screen resizing
    window.addEventListener("resize", updateLinkTarget);

    $(document).ready(function() {
        var accordions = $(".accordion-item");

        accordions.each(function() {
            var accordion = $(this);
            var collapseElement = accordion.find(".collapse");

            collapseElement.on("show.bs.collapse", function() {
                // accordions.removeClass("active");
                accordion.addClass("active");
            });

            collapseElement.on("hidden.bs.collapse", function() {
                accordion.removeClass("active");
            });
        });
        // Prevent accordion from closing when clicking a link inside it
        $(".accordion-item a").on("click", function(event) {
            event.stopPropagation(); // Stops Bootstrap from handling this click
        });
    });

});